import { render, staticRenderFns } from "./WorkflowOutbox.vue?vue&type=template&id=bece28ea&"
import script from "./WorkflowOutbox.vue?vue&type=script&lang=js&"
export * from "./WorkflowOutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports